"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _params = require("../../../utils/params");

var _userAgent = require("ecosystem-marketplace-core/utils/userAgent");

var _ReviewsActions = require("../../../actions/ReviewsActions");

var _immutable = _interopRequireDefault(require("immutable"));

var RequestState = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/RequestState"));

var LIST_QUERIES = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/reviews/ReviewsListQueries"));

var _details = require("../../../selectors/details");

var _requestStates = require("../../../selectors/requestStates");

var _usageTracker = require("../../../utils/usageTracker");

var _ref;

var PAGE_KEY = LIST_QUERIES.PAGE_KEY,
    FILTER_KEY = LIST_QUERIES.FILTER_KEY,
    SORT_KEY = LIST_QUERIES.SORT_KEY,
    STATE_TO_QUERY = LIST_QUERIES.STATE_TO_QUERY,
    REVIEWS_PER_PAGE = LIST_QUERIES.REVIEWS_PER_PAGE;
var initialState = new _immutable.default.Map((_ref = {}, (0, _defineProperty2.default)(_ref, PAGE_KEY, 1), (0, _defineProperty2.default)(_ref, FILTER_KEY, LIST_QUERIES.FILTER.ALL), (0, _defineProperty2.default)(_ref, SORT_KEY, LIST_QUERIES.SORT.NEWEST), _ref));

var withReviewsQueryState = function withReviewsQueryState(WrappedComponent) {
  return function (props) {
    var tracker = (0, _usageTracker.getUsageTracker)();

    var _useParams = (0, _reactRouterDom.useParams)(),
        slug = _useParams.slug;

    var getListingView = (0, _details.makeGetListingView)();
    var listingView = (0, _reactRedux.useSelector)(function (state) {
      return getListingView(state, {
        slug: slug
      });
    });
    var reviewStatsFetchStatus = (0, _reactRedux.useSelector)(_requestStates.getReviewStatsRequestState);
    var reviewsFetchStatus = (0, _reactRedux.useSelector)(_requestStates.getReviewsFetchRequestState);
    var incomingOfferingId = listingView.offeringId;
    var isPrerenderUserAgent = (0, _userAgent.getIsPrerenderUserAgent)();
    var match = (0, _reactRouterDom.useRouteMatch)();
    var isAllReviews = (0, _params.getIsAllReviews)(match);
    var reduxDispatch = (0, _reactRedux.useDispatch)();
    var eventProperties = (0, _react.useMemo)(function () {
      var additionalEventProperties = isAllReviews ? {
        screen: 'all reviews',
        section: 'all reviews'
      } : {
        screen: 'detail',
        section: 'review'
      };
      return (0, _extends2.default)({}, listingView.getEventProperties(), additionalEventProperties);
    }, [isAllReviews, listingView]);
    var trackInteraction = (0, _react.useCallback)(function (action, value) {
      tracker.track('listing-detail-interaction', (0, _extends2.default)({
        action: action,
        value: value
      }, eventProperties));
    }, [tracker, eventProperties]); // Clean up when component unmounts

    (0, _react.useEffect)(function () {
      return function () {
        reduxDispatch((0, _ReviewsActions.resetReviewsFetch)());
        reduxDispatch((0, _ReviewsActions.resetReviewsStatsFetch)());
      };
    }, [reduxDispatch]); // action.type is one of queryState keys: [ PAGE, SORT, FILTER ]
    // action.payload is the value of the query type (e.g. HIGHEST, THREE_STARS, 4)

    var reducer = (0, _react.useCallback)(function (queryState, action) {
      reduxDispatch((0, _ReviewsActions.resetReviewsFetch)());
      return queryState.set(action.type, action.payload);
    }, [reduxDispatch]);

    var _useReducer = (0, _react.useReducer)(reducer, initialState),
        _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
        queryState = _useReducer2[0],
        queryStateDispatch = _useReducer2[1];

    (0, _react.useEffect)(function () {
      if (reviewsFetchStatus === RequestState.UNINITIALIZED) {
        if (isPrerenderUserAgent && isAllReviews) {
          reduxDispatch((0, _ReviewsActions.getAllReviews)(incomingOfferingId));
        } else {
          reduxDispatch((0, _ReviewsActions.getReviews)((0, _extends2.default)({
            offeringId: incomingOfferingId,
            offset: queryState.get(PAGE_KEY) * REVIEWS_PER_PAGE - REVIEWS_PER_PAGE
          }, STATE_TO_QUERY[queryState.get(FILTER_KEY)], STATE_TO_QUERY[queryState.get(SORT_KEY)])));
        }
      }
    }, [reduxDispatch, reviewsFetchStatus, queryState, incomingOfferingId, isPrerenderUserAgent, isAllReviews]);
    (0, _react.useEffect)(function () {
      if (reviewStatsFetchStatus === RequestState.UNINITIALIZED) {
        reduxDispatch((0, _ReviewsActions.getReviewsStats)(incomingOfferingId));
      }
    }, [reduxDispatch, reviewStatsFetchStatus, incomingOfferingId]);

    var _useMemo = (0, _react.useMemo)(function () {
      return [SORT_KEY, FILTER_KEY, PAGE_KEY].map(function (textKey) {
        return function (_ref2) {
          var value = _ref2.target.value;
          trackInteraction("change reviews " + textKey.toLowerCase(), "" + value);
          queryStateDispatch({
            type: textKey,
            payload: value
          });
        };
      });
    }, [queryStateDispatch, trackInteraction]),
        _useMemo2 = (0, _slicedToArray2.default)(_useMemo, 3),
        onSortChange = _useMemo2[0],
        onFilterChange = _useMemo2[1],
        onPageChange = _useMemo2[2];

    return _react.default.createElement(WrappedComponent, (0, _extends2.default)({}, props, {
      queryState: queryState,
      onSortChange: onSortChange,
      onFilterChange: onFilterChange,
      onPageChange: onPageChange
    }));
  };
};

var _default = withReviewsQueryState;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/reviews/withReviewsQueryState.js
// module id = 431
// module chunks = 209 210 211 212